export enum ReferralAuthorizationStatus {
  Active = 'active',
  Expired = 'expired',
  NotStarted = 'not_started',
  Canceled = 'canceled'
}

export interface IReferralAuthorizationApiResponse {
  /* eslint-disable @typescript-eslint/naming-convention */
  auth_number: string;
  therapy_type: string;
  start_date: string;
  expiration_date: string;
  status: string;
  /* eslint-enable @typescript-eslint/naming-convention */
}

export class ReferralAuthorization {
  authNumber: string;
  therapyType: string;
  startDate: string;
  expirationDate: string;
  status: ReferralAuthorizationStatus;

  load_from_json(json: any): ReferralAuthorization {
    this.authNumber = json.authNumber;
    this.therapyType = json.therapyType;
    this.startDate = json.startDate;
    this.expirationDate = json.expirationDate;
    this.status = ReferralAuthorization.normalizeStatus(json.status);

    return this;
  }

  // Build from the snake_case referral-detail payload.
  static fromApiResponse(json: IReferralAuthorizationApiResponse): ReferralAuthorization {
    const auth = new ReferralAuthorization();
    auth.authNumber = json.auth_number;
    auth.therapyType = json.therapy_type;
    auth.startDate = json.start_date;
    auth.expirationDate = json.expiration_date;
    auth.status = ReferralAuthorization.normalizeStatus(json.status);

    return auth;
  }

  // Kept as the raw trimmed string (not coerced), so an unknown status stays non-matching.
  private static normalizeStatus(raw: string): ReferralAuthorizationStatus {
    return (raw ?? '').trim() as ReferralAuthorizationStatus;
  }
}
